import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ProfilePic } from "../../assets/profile-pic.svg";
import { setNotifTo } from "../../store";
import classNames from "classnames";
import { useEffect } from "react";

function Notification() {
  const dispatch = useDispatch();
  const { notifText } = useSelector((state) => state.app);

  useEffect(() => {
    notifText &&
      setTimeout(() => {
        notifText && dispatch(setNotifTo(null));
      }, 4000);
  }, [dispatch, notifText]);

  if (!notifText) return null;

  return (
    <div
      className={classNames(
        "fixed left-0 right-0 mx-auto mt-2 w-4/5 pl-notif-banner transition-transform rounded overflow-hidden flex flex-col z-50"
      )}
    >
      <div className="h-9 w-full bg-black flex flex-row items-center px-1">
        <ProfilePic />
        <span className="grow pl-notif-name pl-2">Rohan</span>
        <div className="h-full aspect-square relative">
          <svg
            className="absolute top-0 left-0 right-0 bottom-0 m-auto cursor-pointer"
            onClick={() => {
              dispatch(setNotifTo(null));
            }}
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.30017 6.50017C8.14664 6.50017 7.99295 6.55865 7.87595 6.67595L6.67595 7.87595C6.44135 8.11055 6.44135 8.49039 6.67595 8.72439L11.0517 13.1002L6.67595 17.4759C6.44135 17.7105 6.44135 18.0904 6.67595 18.3244L7.87595 19.5244C8.11055 19.759 8.49039 19.759 8.72439 19.5244L13.1002 15.1486L17.4759 19.5244C17.7099 19.759 18.0904 19.759 18.3244 19.5244L19.5244 18.3244C19.759 18.0898 19.759 17.7099 19.5244 17.4759L15.1486 13.1002L19.5244 8.72439C19.759 8.49039 19.759 8.10995 19.5244 7.87595L18.3244 6.67595C18.0898 6.44135 17.7099 6.44135 17.4759 6.67595L13.1002 11.0517L8.72439 6.67595C8.60709 6.55865 8.45369 6.50017 8.30017 6.50017Z"
              fill="#00FFB3"
            />
            <circle
              cx="13"
              cy="13"
              r="12"
              stroke="#00835B"
              strokeWidth="2"
              className="pl-notif-close-progress"
            />
          </svg>
        </div>
      </div>
      <div className="pl-notif-text rounded-b">{notifText}</div>
    </div>
  );
}

export default Notification;
